module.exports = __webpack_public_path__ + "img/fastcharger-rejected-semipublic.6d405f05.svg";